/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import PerfectScrollbar from "react-perfect-scrollbar";
import { BrowserRouter } from "react-router-dom";

import { ArgonControllerProvider } from "context";

import App from "./App";

// Soft UI Context Provider

// react-perfect-scrollbar component
import "./i18n";
import "react-perfect-scrollbar/dist/css/styles.css";
import { SessionProvider } from "0.Mine/2.Context/sessionContext";

import { SnackbarProvider } from "notistack";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <SessionProvider>
      <ArgonControllerProvider>
        <PerfectScrollbar>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            autoHideDuration={5000}
          >
            <App />
          </SnackbarProvider>
        </PerfectScrollbar>
      </ArgonControllerProvider>
    </SessionProvider>
  </BrowserRouter>
);
